import React from 'react';
import { CalculatorFormState } from '../types';

interface AppointmentFormProps {
    values: CalculatorFormState;
    onFieldChange: (field: keyof CalculatorFormState, value: number) => void;
    onSubmit: () => void;
}

const AppointmentForm: React.FC<AppointmentFormProps> = ({ values, onFieldChange, onSubmit }) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        const numericValue = value === '' ? 0 : Number(value);
        onFieldChange(name as keyof CalculatorFormState, numericValue);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onSubmit();
    };

    return (
        <form className="calculator-form" onSubmit={handleSubmit}>
            <fieldset>
                <legend>Lead Flow</legend>
                <div className="form-row">
                    <label htmlFor="monthlyLeads">Monthly Leads</label>
                    <input
                        id="monthlyLeads"
                        name="monthlyLeads"
                        type="number"
                        min={0}
                        step={1}
                        value={values.monthlyLeads}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-row">
                    <label htmlFor="bookingRate">Booking Rate (%)</label>
                    <input
                        id="bookingRate"
                        name="bookingRate"
                        type="number"
                        min={0}
                        max={100}
                        step={1}
                        value={values.bookingRate}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-row">
                    <label htmlFor="showRate">Show Rate (%)</label>
                    <input
                        id="showRate"
                        name="showRate"
                        type="number"
                        min={0}
                        max={100}
                        step={1}
                        value={values.showRate}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-row">
                    <label htmlFor="closeRate">Close Rate (%)</label>
                    <input
                        id="closeRate"
                        name="closeRate"
                        type="number"
                        min={0}
                        max={100}
                        step={1}
                        value={values.closeRate}
                        onChange={handleChange}
                        required
                    />
                </div>
            </fieldset>

            <fieldset>
                <legend>Revenue</legend>
                <div className="form-row">
                    <label htmlFor="averageOrderValue">Average Sale Value ($)</label>
                    <input
                        id="averageOrderValue"
                        name="averageOrderValue"
                        type="number"
                        min={0}
                        step={10}
                        value={values.averageOrderValue}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-row">
                    <label htmlFor="retentionRate">Retention Rate (%)</label>
                    <input
                        id="retentionRate"
                        name="retentionRate"
                        type="number"
                        min={0}
                        max={100}
                        step={1}
                        value={values.retentionRate}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-row">
                    <label htmlFor="retentionMonths">Retention Months</label>
                    <input
                        id="retentionMonths"
                        name="retentionMonths"
                        type="number"
                        min={0}
                        step={1}
                        value={values.retentionMonths}
                        onChange={handleChange}
                        required
                    />
                </div>
            </fieldset>

            <fieldset>
                <legend>Costs</legend>
                <div className="form-row">
                    <label htmlFor="marketingSpend">Monthly Marketing Spend ($)</label>
                    <input
                        id="marketingSpend"
                        name="marketingSpend"
                        type="number"
                        min={0}
                        step={50}
                        value={values.marketingSpend}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-row">
                    <label htmlFor="fixedCosts">Other Monthly Costs ($)</label>
                    <input
                        id="fixedCosts"
                        name="fixedCosts"
                        type="number"
                        min={0}
                        step={50}
                        value={values.fixedCosts}
                        onChange={handleChange}
                        required
                    />
                </div>
            </fieldset>

            <div className="form-actions">
                <button type="submit">Calculate ROI</button>
            </div>
        </form>
    );
};

export default AppointmentForm;
